import { render } from "./AddStockOut.vue?vue&type=template&id=2ba36956&scoped=true&ts=true"
import script from "./AddStockOut.vue?vue&type=script&lang=ts"
export * from "./AddStockOut.vue?vue&type=script&lang=ts"

import "./AddStockOut.vue?vue&type=style&index=0&id=2ba36956&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba36956"]])

export default __exports__